// extracted by mini-css-extract-plugin
export default {"rating":"vC-z","numberOfStars":"wC-z","count":"xC-z","barGraphSpacing":"yC-z","barGraph":"zC-z"};